import { render, staticRenderFns } from "./BaseText.vue?vue&type=template&id=6ddec8cc&scoped=true"
import script from "./BaseText.vue?vue&type=script&lang=ts"
export * from "./BaseText.vue?vue&type=script&lang=ts"
import style0 from "./BaseText.vue?vue&type=style&index=0&id=6ddec8cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddec8cc",
  null
  
)

export default component.exports